
      module.exports = {
        functional: true,
        render(_h, _vm) {
          const { _c, _v, data, children = [] } = _vm;

          const {
            class: classNames,
            staticClass,
            style,
            staticStyle,
            attrs = {},
            ...rest
          } = data;

          return _c(
            'svg',
            {
              class: [classNames,staticClass],
              style: [style,staticStyle],
              attrs: Object.assign({"xmlns":"http://www.w3.org/2000/svg","viewBox":"0 0 16 17","fill":"none"}, attrs),
              ...rest,
            },
            children.concat([_c('g',{attrs:{"clip-path":"url(#clip0_14908_488030)","stroke":"#545C69","stroke-linecap":"round","stroke-linejoin":"round"}},[_c('path',{attrs:{"d":"M13.923 1.988H2.077C1.482 1.988 1 2.47 1 3.065v11.846c0 .595.482 1.077 1.077 1.077h11.846c.595 0 1.077-.482 1.077-1.077V3.065c0-.595-.482-1.077-1.077-1.077zM5.305 6.297h5.384M5.305 8.988h5.384M7.133 11.68h5.384"}})]),_c('defs',[_c('clipPath',{attrs:{"id":"clip0_14908_488030"}},[_c('path',{attrs:{"fill":"#fff","transform":"translate(0 .988)","d":"M0 0h16v16H0z"}})])])])
          )
        }
      }
    